import React from "react";
import CustomTooltip from "../../Elements/Tooltip";

/**
 * Reusable action icons component for Admin tables
 * Provides consistent Edit and Delete icons with tooltips
 */
const AdminActionIcons = ({
  onEdit,
  onDelete,
  itemName = "item",
  showEdit = true,
  showDelete = true
}) => {
  return (
    <div className="admin-action-icons">
      {showEdit && (
        <CustomTooltip title={<p className="p-1 text-light">Edit</p>} placement="top">
          <img
            src="/icons/edit.svg"
            alt=""
            className="me-2 cursor-pointer admin-action-icon"
            onClick={onEdit}
            aria-label={`Edit ${itemName}`}
            role="button"
          />
        </CustomTooltip>
      )}
      {showDelete && (
        <CustomTooltip title={<p className="p-1 text-light">Delete</p>} placement="top">
          <img
            src="/icons/delete.svg"
            alt=""
            className="cursor-pointer admin-action-icon"
            onClick={onDelete}
            aria-label={`Delete ${itemName}`}
            role="button"
          />
        </CustomTooltip>
      )}
    </div>
  );
};

export default AdminActionIcons;
